import { inject, injectable } from "inversify";
import { IDefaultResponse } from "../../types";
import { ISlackPayload, ISlackMessage } from "../ports/SlackMessage";
import { type HttpClient } from "@/core/services/protocols/types";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";

export interface ISuccessModelSlack {
  ContaBancariaId: string;
  itemData: string;
}

@injectable()
export default class SlackMessageAdapter implements ISlackMessage {
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async enviarMensagem(payload: ISlackPayload): Promise<void> {
    const isLocal = window.location.origin.includes("localhost");
    if (isLocal) return;

    await this.httpClient?.post<IDefaultResponse>({
      url: "/SlackUtilAPI/SendSlackMessage",
      body: {
        ...payload
      }
    });
  }
}
